import React from "react";
import "../css2/PanicAnchor.css";

export default function HelprrPanicAnchor() {
  return (
    <div className="pa-wrapper">
      <div className="pa-card">
        {/* Left: Text */}
        <div className="pa-text">
          <div className="pa-pill">Panic Support</div>
          <h2 className="pa-title">Panic Anchor</h2>
          <p className="pa-subtitle">
            When panic rises, we give your mind one safe thing to focus on.
            Let this anchor be your “home base” while your body settles.
          </p>

          <ol className="pa-steps">
            <li>Gently bring your eyes to the circle on the right.</li>
            <li>Notice its colour, edges, and the soft glow around it.</li>
            <li>Breathe in as it grows slightly, and breathe out as it softens.</li>
            <li>If your mind wanders, that’s okay. Kindly bring it back here.</li>
          </ol>

          <p className="pa-footnote">
            You don’t need to “feel calm” right away. All you’re doing is giving
            your system something steady and predictable to hold onto.
          </p>
        </div>

        {/* Right: Anchor Visual */}
        <div className="pa-visual">
          <div className="pa-orbit">
            <div className="pa-anchor-circle" />
          </div>
        </div>
      </div>
    </div>
  );
}
